import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "harf-kulesi",
  name: "Harf Kulesi",
  tagline: "Harfleri diz, kelimeyi bul, kuleyi yükselt.",
  inspiredBy: "Falling blocks × word puzzle",
  secondLayer: "Only valid words in the player's language (TR/EN) clear; long words and cascades multiply the score.",
  accent: "#8ac926",
  status: "lab",
};
